import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    background: {
      minHeight: "100%",
      background: theme.palette.makeBackgrounds.default,
    },
    root: {
      paddingTop: 23,
      paddingBottom: 64,
      [theme.breakpoints.up("mobile")]: {
        paddingTop: 36,
        paddingBottom: 73,
      },
      [theme.breakpoints.up("tablet")]: {
        paddingTop: 51,
        paddingBottom: 248,
      },
    },
    rootToVertical: {
      [theme.breakpoints.up("tablet")]: {
        paddingTop: 121,
        paddingBottom: 248,
      },
    },
    title: {
      marginBottom: 16,
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 34,
      },
      [theme.breakpoints.up("tablet")]: {
        marginBottom: 45,
      },
    },
    player: {
      [theme.breakpoints.up("mobile")]: {
        width: 574,
        margin: [0, "auto"],
      },
      [theme.breakpoints.up("tablet")]: {
        width: 778,
      },
    },
  }),
  { name: "Make" },
);
